var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 22,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 3.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 10.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13 5 6 9M5.5 12.5 13 17"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 18.5,
  r: 2.5
}))));
export default SvgShare;